import { change, touch } from 'redux-form';
import { geocodeByAddress } from 'react-places-autocomplete';
import Honeybadger from 'honeybadger-js';
import parseGooglePlace from 'lib/parseGooglePlace';
import { updateCurrencies, updateZip } from 'actions/formActions';
import { triggerFormValidation, clearAddressErrors } from 'actions/submissionFormActions';
import get from 'lodash/get';
import pick from 'lodash/pick';

const geocodeByPlaceId = (googlePlaceId, service) => {
  return new Promise(function(resolve,reject) {
    service.getDetails( { placeId: googlePlaceId }, (results, status) => {
      if (status == window.google.maps.places.PlacesServiceStatus.OK) {
        resolve(results);
      } else {
        reject(status);
      }
    });
  });
};

export const loadPlaceDataFromPlaceId = (googlePlaceId, address = null) => (dispatch, getState) => {
  const fullAddress = address || get(getState().form.eventSubmission.values, 'venue.full_address', null);
  const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));

  dispatch(clearAddressErrors());

  geocodeByPlaceId(googlePlaceId, placesService)
    .then(results => dispatch(handleGooglePlaceResult(results, fullAddress, googlePlaceId)));
};

export const loadPlaceDataFromVenue = venue => dispatch => {
  const address = [venue.address_1, venue.town, get(venue, 'country.name')].join(', ');

  geocodeByAddress(address)
    .then(results => dispatch(handleGooglePlaceResult(results, address, results[0].googlePlaceId, true)))
    .catch(error => Honeybadger.notify(error, {
      name: 'Google Place Error',
      context: error
    }));
};

const handleGooglePlaceResult = (result, fullAddress, googlePlaceId, justCoordinates = false) => (dispatch, getState) => {
  const parsedAddress = parseGooglePlace(result);
  const address1 = parsedAddress.streetNumber || parsedAddress.streetName
    ? [parsedAddress.streetNumber, parsedAddress.streetName].join(' ')
    : parsedAddress.city;
  const country = getState().countries.get('list').find((e) => e.get('iso_alpha2') === parsedAddress.countryShort);
  const address = fullAddress || [parsedAddress.address, parsedAddress.city, parsedAddress.countryLong].join(', ');

  const data = {
    full_address: address,
    place_id: googlePlaceId,
    name: result.name,
    address_components: result.address_components,
    types: result.types,
    lat: result.geometry.location.lat(),
    lng: result.geometry.location.lng(),
    address_1: address1,
    town: parsedAddress.city,
    state: { name: parsedAddress.stateLong, code: parsedAddress.stateShort },
    country: country ? country.toJS() : null,
    post_code: parsedAddress.zipCode
  };


  if (justCoordinates) {
    const oldData = getState().form.eventSubmission.values.venue;
    const newData = pick(data, ['lat', 'lng', 'address_components', 'types']);
    dispatch(change('eventSubmission', 'venue', Object.assign({}, oldData, newData)));
  } else {
    dispatch(change('eventSubmission', 'venue', data));
    checkIfVenueIsValid(dispatch);
    updateCurrencies(dispatch, getState, data.country);
    updateZip(dispatch, getState, data.post_code, data.country);
  }
};

const checkIfVenueIsValid = (dispatch) => {
  dispatch(triggerFormValidation());
  dispatch(touch('eventSubmission', 'venue.town'));
  dispatch(touch('eventSubmission', 'venue.post_code'));
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/googlePlaceActions.js